export default "__VITE_ASSET__$SnJa1_l__"